module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notes && _vm.projects && _vm.assets && _vm.members && _vm.categories) ? _c('section', {
    staticClass: "mentor-dashboard"
  }, [_c('timeline'), _vm._v(" "), _c('div', {
    staticClass: "row text-right"
  }, [_c('i', {
    staticClass: "fa fa-expand",
    on: {
      "click": function($event) {
        _vm.toggleExpand()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('mentor-calendar', {
    attrs: {
      "members": _vm.members,
      "projects": _vm.projects,
      "feed": _vm.feed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 panel main-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('ul', {
    staticClass: "filters"
  }, [_c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.project),
      expression: "query.project"
    }],
    staticClass: "proj form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.query.project = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getNotes($event, 'project')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Project")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      style: ({
        backgroundColor: project.color
      }),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                                        " + _vm._s(project.name) + "\n                                    ")])
  })], 2)]), _vm._v(" "), _c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.asset),
      expression: "query.asset"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.query.asset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getNotes($event, 'asset')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Asset")]), _vm._v(" "), _vm._l((_vm.assets), function(asset) {
    return _c('option', {
      style: ({
        backgroundColor: _vm.getProjectColor(asset.projectId)
      }),
      domProps: {
        "value": asset.id
      }
    }, [_vm._v("\n                                        " + _vm._s(asset.name) + "\n                                    ")])
  })], 2)]), _vm._v(" "), _c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.category),
      expression: "query.category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.query.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getNotes($event, 'category')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Task")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.id
      }
    }, [_vm._v("\n                                        " + _vm._s(category.name) + "\n                                    ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, _vm.search]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 completed-filter"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.query.completed = !_vm.query.completed;
        _vm.getNotes($event, 'completed')
      }
    }
  }, [(_vm.query.completed) ? _c('span', [_vm._v("Hide")]) : _c('span', [_vm._v("Show")]), _vm._v(" Completed")])])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-wrapper"
  }, [(_vm.timelineNotes) ? _c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.timelineNotes), function(value, key) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goToDate(key)
        }
      }
    }, [_c('div', {
      staticClass: "day"
    }, [_vm._v(_vm._s(_vm._f("timelineDate")(key)))]), _vm._v(" "), _c('div', {
      staticClass: "bubbles"
    }, _vm._l((value), function(project) {
      return _c('span', {
        staticClass: "bubble",
        style: ({
          backgroundColor: _vm.getProjectColor(project)
        })
      })
    }))])
  })) : _vm._e()]), _vm._v(" "), _c('ul', {
    ref: "notes",
    staticClass: "notes",
    attrs: {
      "id": "notes"
    },
    on: {
      "scroll": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, _vm._l((_vm.notes), function(note, $index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.query.completed === true || (_vm.query.completed === false && note.completed !== true)),
        expression: "query.completed === true || (query.completed === false && note.completed !== true)"
      }],
      key: note.id,
      attrs: {
        "id": 'note' + note.id
      },
      on: {
        "dragover": _vm.dragover,
        "drop": function($event) {
          _vm.attachStructure($event, note, $index)
        }
      }
    }, [(note.location && _vm.showMeetingNote(note)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-3 col-md-3 col-lg-2 text-center campus-meeting-avatars"
    }, _vm._l((note.participants), function(participant) {
      return _c('img', {
        staticClass: "avatar",
        attrs: {
          "src": _vm.getAvatar(participant)
        }
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("longDate")(note.createdAt)) + " "), (note.author == _vm.localStorage.user_id) ? _c('i', {
      staticClass: "fa fa-remove delete-note",
      on: {
        "click": function($event) {
          _vm.deleteNote(note.id, $index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 col-md-9 col-lg-10 clearfix campus-meeting"
    }, [_vm._v("\n                                Mentor Meeting, " + _vm._s(_vm.getLocationName(note.location)) + "\n                                "), (note.meetingNote[0]) ? _c('div', {
      staticClass: "meeting-notes"
    }, [_vm._v("\n                                    " + _vm._s(note.meetingNote[0].text) + "\n                                ")]) : _vm._e(), _vm._v(" "), (!note.meetingNote[0]) ? _c('div', {
      staticClass: "confirm-attendance"
    }, [_c('label', [_vm._v("Did you attend? \n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (note.attended),
        expression: "note.attended"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(note.attended) ? _vm._i(note.attended, null) > -1 : (note.attended)
      },
      on: {
        "__c": function($event) {
          var $$a = note.attended,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (note.attended = $$a.concat([$$v]))
            } else {
              $$i > -1 && (note.attended = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            note.attended = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-check-square-o"
    }), _c('i', {
      staticClass: "fa fa-square-o"
    })]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.createMeetingNote(note)
        }
      }
    }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), (note.meetingNote[0] && !note.meetingNote[0].text) ? _c('div', {
      staticClass: "attendance-confirmed text-right"
    }, [_vm._v("\n                                        Attended\n                                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!note.location) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-3 col-md-3 col-lg-2 text-center"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.getAvatar(note.author)
      },
      on: {
        "click": function($event) {
          _vm.feed = note.author
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("longDate")(note.createdAt)) + " "), (note.author == _vm.localStorage.user_id) ? _c('i', {
      staticClass: "fa fa-remove delete-note",
      on: {
        "click": function($event) {
          _vm.deleteNote(note.id, $index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 col-md-9 col-lg-10 clearfix note-text",
      class: {
        'dark': note.projectIds.length > 0 && note.projectIds[0] !== 'none', 'completed': note.completed
      },
      style: ({
        backgroundImage: _vm.noteColor(note.projectIds)
      }),
      attrs: {
        "data-id": note.id,
        "data-created": note.createdAt
      }
    }, [_c('i', {
      directives: [{
        name: "fcevent",
        rawName: "v-fcevent"
      }],
      staticClass: "fa fa-arrows drag-note",
      attrs: {
        "data-id": note.id,
        "data-created": note.createdAt
      }
    }), _vm._v(" "), (note.author == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('div', {
      staticClass: "edit"
    }, [(_vm.noteToEdit.noteId === note.id) ? _c('i', {
      staticClass: "save-edited-note fa fa-save",
      on: {
        "click": function($event) {
          _vm.updateNote(note)
        }
      }
    }) : _c('i', {
      staticClass: "edit-note fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.noteToEdit.noteId = note.id
        }
      }
    })]) : _vm._e(), _vm._v(" "), ((!note.categoryIds || note.categoryIds.length === 0)) ? _c('div', [(note.author == _vm.localStorage.user_id) ? _c('editable', {
      directives: [{
        name: "focus",
        rawName: "v-focus.lazy",
        value: (_vm.noteToEdit.noteId === note.id),
        expression: "noteToEdit.noteId===note.id",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "text",
      attrs: {
        "content": note.text
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "update": function($event) {
          _vm.noteToEdit.text = $event
        }
      }
    }) : _vm._e(), _vm._v(" "), (note.author != _vm.localStorage.user_id) ? _c('div', {
      staticClass: "text uneditable"
    }, [_vm._v(_vm._s(note.text))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (note.completed !== null) ? _c('div', {
      staticClass: "tasks"
    }, [_c('div', {
      staticClass: "task-editor"
    }, [_c('ul', {
      staticClass: "tasks"
    }, _vm._l((note.tasks), function(task, $taskIndex) {
      return _c('li', [_c('div', {
        staticClass: "task-wrapper"
      }, [_c('label', [_c('i', {
        staticClass: "fa",
        class: {
          'fa-check-square': task.completed === true,
            'fa-square': task.completed === false
        },
        on: {
          "click": function($event) {
            task.completed = !task.completed;
            _vm.updateTask({
              type: 'change'
            }, task, $index, $taskIndex)
          }
        }
      })]), _vm._v(" "), (!_vm.localStorage.roles.includes('Admin') && _vm.selectedTask === 'n' + note.id + '_t' + task.id && note.author == _vm.localStorage.user_id) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (task.name),
          expression: "task.name"
        }],
        ref: 'n' + note.id + '_t' + task.id,
        refInFor: true,
        staticClass: "task-name",
        attrs: {
          "type": "text",
          "placeholder": "Add Task"
        },
        domProps: {
          "value": (task.name)
        },
        on: {
          "keyup": function($event) {
            _vm.updateTask($event, task, $index, $taskIndex, note.tasks.length)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            task.name = $event.target.value
          }
        }
      }) : _c('div', {
        staticClass: "task",
        domProps: {
          "innerHTML": _vm._s(task.name)
        },
        on: {
          "click": function($event) {
            _vm.selectedTask = 'n' + note.id + '_t' + task.id
          }
        }
      })]), _vm._v(" "), (task.children) ? _c('ul', {
        staticClass: "task-children",
        class: {
          'dark': note.projectIds.length > 0 && note.projectIds[0] !== 'none'
        }
      }, _vm._l((task.children), function(child, $taskChildIndex) {
        return _c('li', [_c('label', [_c('i', {
          staticClass: "fa",
          class: {
            'fa-check-square': child.completed === true,
              'fa-square': child.completed === false
          },
          on: {
            "click": function($event) {
              child.completed = !child.completed;
              _vm.updateTask({
                type: 'change'
              }, task)
            }
          }
        })]), _vm._v("\n                                                        " + _vm._s('n' + note.id + '_t' + task.id) + "\n                                                        "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (child.name),
            expression: "child.name"
          }],
          staticClass: "task-name",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (child.name)
          },
          on: {
            "keyup": function($event) {
              _vm.updateTask($event, child, $index, $taskIndex, note.tasks.length)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              child.name = $event.target.value
            }
          }
        })])
      })) : _vm._e()])
    }))])]) : _vm._e(), _vm._v(" "), (note.attachments && note.attachments.length > 0) ? _c('ul', {
      staticClass: "attachments clearfix"
    }, _vm._l((note.attachments), function(attachment, $attachmentIndex) {
      return (_vm.isVideo(attachment) || _vm.isImage(attachment)) ? _c('li', {
        on: {
          "click": function($event) {
            _vm.openLightbox(note.attachments, $attachmentIndex)
          }
        }
      }, [(_vm.isVideo(attachment)) ? _c('video', [_c('source', {
        attrs: {
          "src": attachment
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
        attrs: {
          "src": _vm.getThumbnail(attachment)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "hover"
      }, [(_vm.isVideo(attachment)) ? _c('img', {
        attrs: {
          "src": "static/static/img/play.png"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
        attrs: {
          "src": "static/static/img/magnify.png"
        }
      }) : _vm._e()])]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (note.attachments && note.attachments.length > 0) ? _c('ul', {
      staticClass: "files"
    }, _vm._l((note.attachments), function(attachment) {
      return (!_vm.isVideo(attachment) && !_vm.isImage(attachment)) ? _c('li', [_c('a', {
        attrs: {
          "href": attachment,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.split('/').pop()))])]) : _vm._e()
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!note.location && !note.week) ? _c('div', {
      staticClass: "row nopad"
    }, [_c('div', {
      staticClass: "col-xs-10 col-xs-push-2 nopad note-footer"
    }, [_vm._l((note.projectIds), function(project, $projectIndex) {
      return (project !== 'none') ? _c('span', [(_vm.noteToEdit.noteId === note.id) ? _c('i', {
        staticClass: "fa fa-remove",
        on: {
          "click": function($event) {
            _vm.removeStructure($index, 'projectIds', project)
          }
        }
      }) : _vm._e(), _vm._v("\n                                    " + _vm._s(_vm.projectName(project))), ($projectIndex < note.projectIds.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (note.projectIds.length > 0 && note.projectIds[0] !== 'none' && (note.assetIds.length > 0 || note.categoryIds.length > 0)) ? _c('span', [_vm._v("\n                                    >")]) : _vm._e(), _vm._v(" "), _vm._l((note.assetIds), function(asset, $assetIndex) {
      return _c('span', [(_vm.noteToEdit.noteId === note.id) ? _c('i', {
        staticClass: "fa fa-remove",
        on: {
          "click": function($event) {
            _vm.removeStructure($index, 'assetIds', asset)
          }
        }
      }) : _vm._e(), _vm._v("\n                                    " + _vm._s(_vm.assetName(asset))), ($assetIndex < note.assetIds.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), _vm._v(" "), (note.assetIds.length > 0 && note.categoryIds.length > 0) ? _c('span', [_vm._v(">")]) : _vm._e(), _vm._v(" "), _vm._l((note.categoryIds), function(category, $categoryIndex) {
      return _c('span', [(_vm.noteToEdit.noteId === note.id) ? _c('i', {
        staticClass: "fa fa-remove",
        on: {
          "click": function($event) {
            _vm.removeStructure($index, 'categoryIds', _vm.asset)
          }
        }
      }) : _vm._e(), _vm._v("\n                                    " + _vm._s(_vm.categoryName(category))), ($categoryIndex < note.categoryIds.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date row nopad text-right"
    }, [(note.dueDate) ? _c('span', [_vm._v("Due: " + _vm._s(_vm._f("localLongDate")(note.dueDate)))]) : _vm._e(), _vm._v(" "), (note.dueDate && new Date(note.dueDate) > new Date()) ? _c('span', [_vm._v("("), _c('countdown', {
      attrs: {
        "date": _vm.localTime(note.dueDate),
        "fast": true
      }
    }), _vm._v(")")], 1) : _vm._e()]), _vm._v(" "), (note.children && note.children.length > 0) ? _c('div', {
      staticClass: "row"
    }, [_c('ul', {
      staticClass: "children"
    }, _vm._l((note.children), function(child, $childIndex) {
      return _c('li', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "date"
      }, [(child.author == _vm.localStorage.user_id) ? _c('i', {
        staticClass: "fa fa-remove delete-note",
        on: {
          "click": function($event) {
            _vm.deleteNote(child.id, $index, $childIndex)
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-3 col-md-2 nopad text-center"
      }, [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": _vm.getAvatar(child.author)
        },
        on: {
          "click": function($event) {
            _vm.feed = child.author
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-md-10 note-text"
      }, [(child.author == _vm.localStorage.user_id) ? _c('div', {
        staticClass: "edit"
      }, [(_vm.noteToEdit.noteId === child.id) ? _c('i', {
        staticClass: "save-edited-note fa fa-save",
        on: {
          "click": function($event) {
            _vm.updateNote(child)
          }
        }
      }) : _c('i', {
        staticClass: "edit-note fa fa-pencil",
        on: {
          "click": function($event) {
            _vm.noteToEdit.noteId = child.id
          }
        }
      })]) : _vm._e(), _vm._v(" "), (child.author == _vm.localStorage.user_id) ? _c('editable', {
        directives: [{
          name: "focus",
          rawName: "v-focus.lazy",
          value: (_vm.noteToEdit.noteId === child.id),
          expression: "noteToEdit.noteId===child.id",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "text",
        attrs: {
          "content": child.text
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          },
          "update": function($event) {
            _vm.noteToEdit.text = $event
          }
        }
      }) : _c('div', {
        staticClass: "text"
      }, [_vm._v(_vm._s(child.text))]), _vm._v(" "), (child.attachments && child.attachments.length > 0) ? _c('ul', {
        staticClass: "attachments"
      }, _vm._l((child.attachments), function(attachment, $attachmentIndex) {
        return (_vm.isVideo(attachment) || _vm.isImage(attachment)) ? _c('li', {
          on: {
            "click": function($event) {
              _vm.openLightbox(child.attachments, $attachmentIndex)
            }
          }
        }, [(_vm.isVideo(attachment)) ? _c('video', [_c('source', {
          attrs: {
            "src": attachment
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
          attrs: {
            "src": _vm.getThumbnail(attachment)
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "hover"
        }, [(_vm.isVideo(attachment)) ? _c('img', {
          attrs: {
            "src": "static/static/img/play.png"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
          attrs: {
            "src": "static/static/img/magnify.png"
          }
        }) : _vm._e()])]) : _vm._e()
      })) : _vm._e(), _vm._v(" "), (child.attachments && child.attachments.length > 0) ? _c('ul', {
        staticClass: "files"
      }, _vm._l((child.attachments), function(attachment) {
        return (!_vm.isVideo(attachment) && !_vm.isImage(attachment)) ? _c('li', [_c('a', {
          attrs: {
            "href": attachment,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(attachment.split('/').pop()))])]) : _vm._e()
      })) : _vm._e()], 1)])])
    }))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row nopad"
    }, [(_vm.replyTo === $index) ? _c('div', {
      staticClass: "nopad col-xs-9 col-xs-push-3 note-taker"
    }, [_c('div', {
      staticClass: "form-group note-taker-wrapper reply-note"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.replyNote.text),
        expression: "replyNote.text",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control reply",
      attrs: {
        "placeholder": "Write reply here"
      },
      domProps: {
        "value": (_vm.replyNote.text)
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          if (!$event.ctrlKey) { return null; }
          _vm.sendReply(note)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.replyNote.text = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "attach",
      attrs: {
        "for": 'replyAttachments' + note.id
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../assets/img/paperclip.png")
      }
    })]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'replyAttachments' + note.id,
        "multiple": ""
      },
      on: {
        "change": function($event) {
          _vm.addAttachments($event, 'reply')
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "send",
      class: {
        'disabled': _vm.uploading === true
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendReply(note)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../assets/img/airplane.png")
      }
    })]), _vm._v(" "), (_vm.replyNote.attachments && _vm.replyNote.attachments.length > 0) ? _c('ul', {
      staticClass: "attachments"
    }, _vm._l((_vm.replyNote.attachments), function(attachment) {
      return (_vm.isVideo(attachment) || _vm.isImage(attachment)) ? _c('li', [(_vm.isVideo(attachment)) ? _c('video', [_c('source', {
        attrs: {
          "src": attachment
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
        attrs: {
          "src": _vm.getThumbnail(attachment)
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (_vm.replyNote.attachments && _vm.replyNote.attachments.length > 0) ? _c('ul', {
      staticClass: "files"
    }, _vm._l((_vm.replyNote.attachments), function(attachment) {
      return (!_vm.isVideo(attachment) && !_vm.isImage(attachment)) ? _c('li', [_c('a', {
        attrs: {
          "href": attachment,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.split('/').pop()))])]) : _vm._e()
    })) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "reply",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.replyTo = null
        }
      }
    }, [_vm._v("Cancel")])]) : _c('span', [(!note.location) ? _c('span', {
      staticClass: "reply",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.replyTo = $index
        }
      }
    }, [_vm._v("Reply")]) : _vm._e()])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "note-taker row nopad"
  }, [_c('div', {
    staticClass: "col-xs-10 nopad"
  }, [_c('div', {
    staticClass: "form-group note-taker-wrapper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newNote.text),
      expression: "newNote.text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Write note here"
    },
    domProps: {
      "value": (_vm.newNote.text)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        if (!$event.ctrlKey) { return null; }
        _vm.addNote()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNote.text = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "attachments",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.addAttachments($event, 'note')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send",
    class: {
      'disabled': _vm.uploading === true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addNote()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/airplane.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "attachments"
  }, _vm._l((_vm.newNote.attachments), function(attachment) {
    return (_vm.isVideo(attachment) || _vm.isImage(attachment)) ? _c('li', [(_vm.isVideo(attachment)) ? _c('video', [_c('source', {
      attrs: {
        "src": attachment
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isImage(attachment)) ? _c('img', {
      attrs: {
        "src": _vm.getThumbnail(attachment)
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.newNote.attachments), function(attachment) {
    return (!_vm.isVideo(attachment) && !_vm.isImage(attachment)) ? _c('li', [_c('a', {
      attrs: {
        "href": attachment,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.split('/').pop()))])]) : _vm._e()
  }))]), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id && !_vm.localStorage.roles.includes('Mentor') && !_vm.localStorage.roles.includes('Admin')) ? _c('div', {
    staticClass: "text-right"
  }, [_vm._v("Notify Mentor of this Post? "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNote.sendNotification),
      expression: "newNote.sendNotification"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newNote.sendNotification) ? _vm._i(_vm.newNote.sendNotification, null) > -1 : (_vm.newNote.sendNotification)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newNote.sendNotification,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newNote.sendNotification = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newNote.sendNotification = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newNote.sendNotification = $$c
        }
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 tags"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNote.projects),
      expression: "newNote.projects"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newNote.projects = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Project")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      style: ({
        backgroundColor: project.color
      }),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                            " + _vm._s(project.name) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNote.assets),
      expression: "newNote.assets"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newNote.assets = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectProject()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Asset")]), _vm._v(" "), _vm._l((_vm.assets), function(asset) {
    return _c('option', {
      style: ({
        backgroundColor: _vm.getProjectColor(asset.projectId)
      }),
      domProps: {
        "value": asset.id
      }
    }, [_vm._v(_vm._s(asset.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNote.categories),
      expression: "newNote.categories"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newNote.categories = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Task")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 sidebar"
  }, [(_vm.members && !_vm.localStorage.roles.includes('Admin')) ? _c('ul', {
    staticClass: "members"
  }, _vm._l((_vm.members), function(member) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.feed = member.id
        }
      }
    }, [_c('div', [(member.avatar) ? _c('img', {
      staticClass: "avatar",
      class: {
        'active': member.id == _vm.feed
      },
      attrs: {
        "src": member.avatar,
        "alt": member.firstName + ' ' + member.lastName,
        "title": member.firstName + ' ' + member.lastName
      }
    }) : _c('img', {
      staticClass: "avatar",
      class: {
        'active': member.id == _vm.feed
      },
      attrs: {
        "src": "static/static/img/mentorship-avatar.jpg",
        "alt": member.firstName + ' ' + member.lastName,
        "title": member.firstName + ' ' + member.lastName
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(member.firstName) + " " + _vm._s(member.lastName) + " \n                            "), (!member.roles.includes('Mentor') && _vm.localStorage.roles.includes('Mentor') && _vm.localStorage.venue === 'both') ? _c('span', [_vm._v("\n                                ("), (member.roles.includes('CampusStudent') || member.transitioned === true) ? _c('span', [_vm._v("Campus")]) : _c('span', [_vm._v("Online")]), _vm._v(")\n                                \n                            ")]) : _vm._e()])])])
  })) : _vm._e(), _vm._v(" "), (_vm.members && _vm.localStorage.roles.includes('Admin')) ? _c('div', {
    staticClass: "members admin"
  }, _vm._l((_vm.members), function(users, id) {
    return _c('ul', _vm._l((users), function(member) {
      return _c('li', {
        class: {
          'is-mentor': member.roles.includes('Mentor')
        },
        on: {
          "click": function($event) {
            _vm.feed = member.id
          }
        }
      }, [(member.roles.includes('Mentor')) ? _c('div', [_vm._v("\n                            " + _vm._s(member.firstName) + " " + _vm._s(member.lastName) + "\n                        ")]) : _c('div', [(member.avatar) ? _c('img', {
        staticClass: "avatar",
        class: {
          'active': member.id == _vm.feed
        },
        attrs: {
          "src": member.avatar,
          "alt": member.firstName + ' ' + member.lastName,
          "title": member.firstName + ' ' + member.lastName
        }
      }) : _c('img', {
        staticClass: "avatar",
        class: {
          'active': member.id == _vm.feed
        },
        attrs: {
          "src": "static/static/img/mentorship-avatar.jpg",
          "alt": member.firstName + ' ' + member.lastName,
          "title": member.firstName + ' ' + member.lastName
        }
      })])])
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('Mentor')) ? _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "schedule-sessions",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showScheduler = true
      }
    }
  }, [_vm._v("\n                    Schedule Meeting(s)\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), (_vm.assets && _vm.projects) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v("Projects / Categories")]), _vm._v(" "), (_vm.projects) ? _c('ul', {
    staticClass: "projects"
  }, _vm._l((_vm.projects), function(project) {
    return _c('li', {
      attrs: {
        "id": 'project_' + project.id,
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          _vm.dragstart($event, project, 'project')
        }
      }
    }, [_c('span', {
      staticClass: "swatch",
      style: ({
        backgroundColor: project.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "structure-name"
    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.projectToEdit = project
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.projectToEdit.id === project.id) ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.projectToEdit.name),
        expression: "projectToEdit.name",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Name"
      },
      domProps: {
        "value": (_vm.projectToEdit.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.projectToEdit.name = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "colors"
    }, _vm._l((_vm.colors), function(color) {
      return _c('li', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.projectToEdit.color),
          expression: "projectToEdit.color"
        }],
        attrs: {
          "type": "radio",
          "id": color
        },
        domProps: {
          "value": color,
          "checked": _vm._q(_vm.projectToEdit.color, color)
        },
        on: {
          "__c": function($event) {
            _vm.projectToEdit.color = color
          }
        }
      }), _vm._v(" "), _c('label', {
        class: {
          'selected': _vm.projectToEdit.color == color
        },
        style: ({
          backgroundColor: color
        }),
        attrs: {
          "for": color
        }
      })])
    })), _vm._v(" "), _c('ul', {
      staticClass: "icons"
    }, [_c('li', [_c('i', {
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteProject()
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "fa fa-save",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updateProject()
        }
      }
    })])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('div', [_c('i', {
    staticClass: "fa fa-plus",
    on: {
      "click": function($event) {
        _vm.projectToEdit = {
          id: null
        };
        _vm.showNewProject = !_vm.showNewProject
      }
    }
  }), _vm._v(" "), (_vm.showNewProject) ? _c('form', {
    staticClass: "new-structure"
  }, [_c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        _vm.showNewProject = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newProject.name),
      expression: "newProject.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.newProject.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newProject.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "colors"
  }, _vm._l((_vm.colors), function(color) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newProject.color),
        expression: "newProject.color"
      }],
      attrs: {
        "type": "radio",
        "id": color
      },
      domProps: {
        "value": color,
        "checked": _vm._q(_vm.newProject.color, color)
      },
      on: {
        "__c": function($event) {
          _vm.newProject.color = color
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'selected': _vm.newProject.color == color
      },
      style: ({
        backgroundColor: color
      }),
      attrs: {
        "for": color
      }
    })])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addProject()
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Assets")]), _vm._v(" "), _c('ul', {
    staticClass: "projects"
  }, _vm._l((_vm.assets), function(asset) {
    return _c('li', {
      attrs: {
        "id": 'asset_' + asset.id,
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          _vm.dragstart($event, asset, 'asset')
        }
      }
    }, [(asset.projectId) ? _c('span', {
      staticClass: "swatch",
      style: ({
        backgroundColor: _vm.getProjectColor(asset.projectId)
      })
    }) : _vm._e(), _c('span', {
      staticClass: "structure-name"
    }, [_vm._v(_vm._s(asset.name))]), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.assetToEdit = asset
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.assetToEdit.id === asset.id) ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.assetToEdit.name),
        expression: "assetToEdit.name",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Name"
      },
      domProps: {
        "value": (_vm.assetToEdit.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.assetToEdit.name = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.assetToEdit.projectId),
        expression: "assetToEdit.projectId"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.assetToEdit.projectId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "default": "",
        "selected": ""
      }
    }, [_vm._v("Project")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
      return _c('option', {
        style: ({
          backgroundColor: project.color
        }),
        domProps: {
          "value": project.id
        }
      }, [_vm._v(_vm._s(project.name))])
    })], 2), _vm._v(" "), _c('ul', {
      staticClass: "icons"
    }, [_c('li', [_c('i', {
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteAsset()
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "fa fa-save",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updateAsset()
        }
      }
    })])])]) : _vm._e()])
  })), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('div', [_c('i', {
    staticClass: "fa fa-plus",
    on: {
      "click": function($event) {
        _vm.assetToEdit = {
          id: null
        };
        _vm.showNewAsset = !_vm.showNewAsset
      }
    }
  }), _vm._v(" "), (_vm.showNewAsset) ? _c('form', {
    staticClass: "new-structure"
  }, [_c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        _vm.showNewAsset = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newAsset.name),
      expression: "newAsset.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.newAsset.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsset.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.projects) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsset.projectId),
      expression: "newAsset.projectId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsset.projectId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Project")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      style: ({
        backgroundColor: project.color
      }),
      domProps: {
        "value": project.id
      }
    }, [_vm._v(_vm._s(project.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAsset()
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Tasks")]), _vm._v(" "), (_vm.categories) ? _c('ul', {
    staticClass: "projects"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', {
      attrs: {
        "id": 'category_' + category.id,
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          _vm.dragstart($event, category, 'category')
        }
      }
    }, [_c('span', {
      staticClass: "structure-name"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.categoryToEdit = category
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.categoryToEdit.id === category.id) ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.categoryToEdit.name),
        expression: "categoryToEdit.name",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Name"
      },
      domProps: {
        "value": (_vm.categoryToEdit.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.categoryToEdit.name = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "icons"
    }, [_c('li', [_c('i', {
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteCategory()
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "fa fa-save",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updateCategory()
        }
      }
    })])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.feed == _vm.localStorage.user_id || _vm.localStorage.roles.includes('Mentor')) ? _c('div', [_c('i', {
    staticClass: "fa fa-plus",
    on: {
      "click": function($event) {
        _vm.categoryToEdit = {
          id: null
        };
        _vm.showNewCategory = !_vm.showNewCategory
      }
    }
  }), _vm._v(" "), (_vm.showNewCategory) ? _c('form', {
    staticClass: "new-structure"
  }, [_c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        _vm.showNewCategory = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newCategory.name),
      expression: "newCategory.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.newCategory.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCategory.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory()
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.lightboxImages) ? _c('div', {
    staticClass: "lightbox",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.lightboxImages = null
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.lightboxImages = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.lightboxImages = null
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "lightbox",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l((_vm.lightboxImages), function(slide) {
    return _c('swiper-slide', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.isVideo(slide)) ? _c('video', {
      attrs: {
        "ontrols": "",
        "controlsList": "nodownload",
        "width": "600",
        "controls": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('source', {
      attrs: {
        "src": slide
      }
    })]) : _c('img', {
      attrs: {
        "src": slide
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-buttons-wrapper"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": slide
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })])])])
  }), _vm._v(" "), (_vm.lightboxImages.length > 1) ? _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), (_vm.lightboxImages.length > 1) ? _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "button-next"
  }) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('Mentor') && _vm.showScheduler === true) ? _c('mentor-session-scheduler', {
    attrs: {
      "members": _vm.members
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hider"
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Mentorship Notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "attach",
    attrs: {
      "for": "attachments"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/paperclip.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Note Structure")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cab63bce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorDashboard.vue
// module id = 2100
// module chunks = 2